import Test from "./Test";

export default class WorkflowSmokeTest extends Test {
  constructor(api) {
    super(api, "Workflow Smoke Test");
  }

  async init() {
    try {
      // Fetch all workflows
      const response = await this.api.get("/workflow");

      // Prepare test cases for each workflow
      return response.map(wf => {
        let label = wf.label || wf.slug;
        return {
          name: `Workflow Test: ${label || "[Unnamed]"}`,
          slug: wf.slug,
          label: label,
          link: this.api.host.replace("/api", "") + "/workflow/" + wf.slug
        };
      });
    } catch (error) {
      // Handle error gracefully
      throw new Error("Failed to load workflows. Error: " + error.message);
    }
  }

  async exec(test) {
    let label = test.label || test.slug;
    // Fetch objects for the workflow
    let baseRoute = test?.slug?.includes("__MOBILE__")
      ? "/mobile/workflow/" + test.slug.replace("__MOBILE__", "")
      : "/workflow/" + test.slug;

    let route = `${baseRoute}/objects`;
    let res = await this.api.get(route, {
      limit: 1,
      fields: "all"
    });
    return res.error
      ? {
          success: false,
          message: `Failed to load objects for workflow ${label}. Error: ${res?.error?.data?.message}`
        }
      : {
          success: true,
          message: `Workflow ${label} passed successfully.`
        };

    // Handle error gracefully;
  }
}
